import React from "react";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { toast } from "react-toastify";
import ls from "local-storage";
import * as CONFIG from "./_config";
import ReactTooltip from "react-tooltip";

toast.configure();

const axios = require("axios");

class Cart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cartlist: null,
      barcode: "",
    };
  }

  componentDidMount() {
    this.GetCart();
    this.MyAccount();
    ls.set("redirectTo", window.location.href);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.GetCart();
      this.MyAccount();
      ls.set("redirectTo", window.location.href);
    }
  }

  GetCart() {
    if (!ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)) {
      this.setState({
        cartlist: [],
      });
      return false;
    }

    const data = new FormData();
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;
    data.append("method", "POST");
    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetMyCartDetails/${UserToken}`;

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        this.setState({
          cartlist: res.data.MyCartInfo,
        });
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  MyAccount() {
    const data = new FormData();
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : "";

    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetMyCardAndSaveAmountInfo/${UserToken}`;

    axios
      .get(apiurl, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        // console.log('res',res);
        this.setState({
          barcode: res.data.BarCodeUrl,
        });
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  removefromCart = async (event, id) => {
    event.preventDefault();
    event.persist();
    if (id) {
      var product = id;

      var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
        ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
        : CONFIG.DATA.GUEST_TOKEN_USER;
      const data = new FormData();
      data.append("method", "POST");

      const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/RemoveFromCart/${product}/${UserToken}`;

      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
        })
        .then((res) => {
          toast.warn("Item removed from the cart!", { autoClose: 2000 });
          this.GetCart();
          this.Notification();
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  };

  Notification() {
    const data = new FormData();
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : "";

    data.append("method", "POST");

    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetMyCartDetails/${UserToken}`;

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        var span =
          res.data.MyCartInfo.length !== 0
            ? '<span class="badge">' + res.data.MyCartInfo.length + "</span>"
            : "";
        document.getElementById("Notificationcount").innerHTML =
          '<img loading="lazy" src="/assets/images/icons/shopingcarticons.png">' +
          span;
        document.getElementById("tip-cart").innerHTML =
          res.data.MyCartInfo.length > 0
            ? "Click to view your shopping cart"
            : "You have no items in your shopping cart";
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  PrintElem = (e) => {
    window.print();
  };

  render() {
    const list =
      this.state.cartlist &&
      this.state.cartlist.map((value, index) => {
        return (
          <tr key={index} className="cart_item">
            <td className="product-thumbnail">
              <img
                loading="lazy"
                width="256"
                height="256"
                src={value.ImagePath}
                className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                alt="Cart Item"
              />
            </td>
            <td className="product-name">
              <Link>
                {value.Title}
                {CONFIG.DATA.BACKEND_HOST === "williams" ? (
                  value.NewsCategoryId == "4" ? (
                    <>{value.ProductName} </>
                  ) : (
                    ""
                  )
                ) : (
                  <> {value.ProductName} </>
                )}
              </Link>
            </td>

            <td
              className="product-quantity product-name"
              style={{ textAlign: "center" }}
            >
              <Link>1</Link>
            </td>
            <td className="product-remove ">
              <Link
                onClick={(e) => {
                  this.removefromCart(e, value.OfferId);
                }}
                className="btn btn-sm btn-rounded remove cart_page_remove hide-print"
                title="Remove this item"
              >
                <i className="icon-remove" />
              </Link>
            </td>
          </tr>
        );
      });

    return (
      <div>
        <div className="main-container default-page pt-5 mt-5  ">
          {CONFIG.DATA.THEME === 2 ? (
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb d-print-none"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">Shopping Cart</h2>
                      {}
                      <ol className="breadcrumb ml-5">
                        <li>
                          <a href={CONFIG.DATA.BASEPATH}>Home</a>
                        </li>
                        <li>
                          <span className="active">Cart</span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <header className="entry-header">
                  <h1 className="entry-title">Shopping Cart </h1>
                </header>
                <div className="breadcrumbs">
                  <Link to="/">Home</Link>
                  <span className="separator">/</span>
                  <a href="/cart" title="Cart">
                    {" "}
                    Cart{" "}
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
        <div>
          <div className="container" id={"divcontents"}>
            <div className="main-container default-page">
              <div className="row mt-2">
                <div style={{ width: "100%" }}>
                  <div className="print-barcode">
                    <span className="print-barcode-text">
                      SHOW THIS BARCODE TO CASHIER
                    </span>
                    <img
                      className="print-barcode-img"
                      alt="Barcode"
                      src={this.state.barcode}
                      style={{ height: "85px" }}
                    />
                  </div>
                  {this.state.cartlist ? (
                    this.state.cartlist.length > 0 ? (
                      <Link
                        className="ptintbuttion"
                        data-tip
                        data-for="tip-print"
                        style={{ float: "right" }}
                        onClick={(event) => this.PrintElem(event)}
                        title="Print"
                      >
                        <img
                          src="/assets/images/print.jpg"
                          className="ptintbuttion"
                          width="50"
                          height="30"
                          name="Print"
                          alt="Print Cart"
                        />
                        <ReactTooltip
                          id="tip-print"
                          place="bottom"
                          type="dark"
                          effect="solid"
                        >
                          Click to print your shopping cart
                        </ReactTooltip>
                      </Link>
                    ) : (
                      <div
                        className="vc_btn3-container vc_btn3-inline"
                        style={{ margin: "200px" }}
                      >
                        <Link
                          to="/"
                          style={{
                            backgroundColor: "#ed1212",
                            color: "#ffffff",
                          }}
                          className="vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-rounded vc_btn3-style-custom"
                          title=""
                        >
                          Return to Shop
                        </Link>
                      </div>
                    )
                  ) : (
                    <div className="content">
                      <div className="overlay">
                        <div
                          className="overlay-content"
                          style={{ position: "inherit", margin: "200px" }}
                        >
                          <img
                            style={{ maxWidth: "none" }}
                            src="/assets/images/loading.gif"
                            alt="Loading..."
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {this.state.cartlist && this.state.cartlist.length > 0 ? (
                <div className="row">
                  <div className="print-barcode-text">My Shopping List</div>
                  <div className="col-md-12 mt-2">
                    <table className="shop_table cart" cellSpacing="0">
                      <thead>
                        <tr>
                          <th className="product-thumbnail"></th>
                          <th className="product-name">Title</th>
                          <th className="product-quantity">Qty</th>
                          <th className="product-remove"></th>
                        </tr>
                      </thead>
                      <tbody>{list}</tbody>
                    </table>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Cart;
